// 这里跟vue2有点区别，vue2中是直接导入vue，然后通过vue.use(xxx)
import { createStore } from 'vuex'

const state = {
    count: 0,
    adminleftnavnum:"/"  //管理后台左侧导航
}
const mutations = {
    increment (state) {
        state.count++
    }
}
//注册Store
const Store = createStore({
    state,
    mutations
});	//返回实例

export default Store